import { fromJS } from 'immutable';

import { createAsyncAction } from '../utils';
const initialState = fromJS({
    loading: false,
    error: null,
    list: []
});

export const getTimePeriods = createAsyncAction('GET_TIME_PERIODS');

export default function reducer(state = initialState, action: any) {
    switch (action.type) {
    case getTimePeriods.REQUEST:
        return fromJS({ ...state.toJS(), loading: true, error: null });
    case getTimePeriods.SUCCESS:
        return fromJS({
            ...state.toJS(),
            loading: false,
            list: [...action.payload, { periodName: 'Custom', custom: true, periodInMilliseconds: 0 }]
        });
    case getTimePeriods.FAIL:
        return fromJS({ ...state.toJS(), loading: false, error: action.payload });
    default:
        return state;
    }
}

export function timePeriodsActions($http: any, api: any) {
    'ngInject';
    function loadTimePeriods() {
        return (dispatch: any) => {
            dispatch({ type: getTimePeriods.REQUEST });
            return $http.get(`${api.restServiceUrlDB}timeperiods`).then(
                (response: any) => {
                    dispatch({ type: getTimePeriods.SUCCESS, payload: response.data });
                },
                (error: any) => {
                    dispatch({ type: getTimePeriods.FAIL, error: true, payload: error.data });
                }
            );
        };
    }

    return { loadTimePeriods };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/newDashBoard/redux/time-periods.ts